import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowId} from "common/flowmaster/types/workflow";
import {Test, TestId} from "common/flowmaster/types/test";

export type WorkflowTestUpdateAction = {
  type: WorkflowsActionTypes["WORKFLOW_TEST_UPDATE"]["SUCCESS"];
  payload: {links: Record<string, unknown>; tests: Test[]};
};

export default function updateWorkflowTest(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_TEST_UPDATE,
    (
      organisationId: OrganisationId,
      workflowContextId: WorkflowId,
      testId: TestId,
      testType: string,
      value: Record<string, unknown>,
    ) => {
      return requestor
        .put(
          `${basePath}/organisation/${organisationId}/workflow_context/${workflowContextId}/test/${testId}`,
          {test_type: testType, value},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
